<ion-header>
	<ion-toolbar>
		<ion-title>Edit</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" color="primary">
				<ion-icon slot="icon-only" name="close-sharp"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
<ng-container *ngrxLet="{ clinicalNote: clinicalNote$, documentInstance: documentInstance$, combinedClinicalNoteAttachments: combinedClinicalNoteAttachments$ } as vm; suspenseTpl: loading">
	@if (vm.clinicalNote && vm.documentInstance) {
		<div class="half-margin-top container">
			<div class="fixed app-padding-horizontal">
				<app-heading background="primary-2">{{ vm.clinicalNote.manifest.name }}</app-heading>
			</div>
			<div class="scroll-vertical">
				<app-clinical-note-document [clinicalNote]="vm.clinicalNote" [documentInstance]="vm.documentInstance" [combinedClinicalNoteAttachments]="vm.combinedClinicalNoteAttachments" [isReadOnly]="false"></app-clinical-note-document>
			</div>
		</div>
	}
	@else {
		<app-spinner class="margin-top"></app-spinner>
	}
</ng-container>
<ng-template #loading>
	<app-spinner class="margin-top"></app-spinner>
</ng-template>